module.exports = __webpack_public_path__ + "static/media/output-onlinepngtools (2).f28d4cff.png";